import React, { useMemo } from "react";
import cn from "classnames";

export const ChevronDown = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M19 9l-7 7-7-7"
      />
    </svg>
  );
};

export const ChevronUp = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M5 15l7-7 7 7"
      />
    </svg>
  );
};

export const Location = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-6 h-6"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
    />
  </svg>
);

export const ChevronLeft = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15 19l-7-7 7-7"
    />
  </svg>
);

export const ChevronRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9 5l7 7-7 7"
    />
  </svg>
);

export const Clock = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  );
};

export const ImageIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
    />
  </svg>
);

export const Close = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  );
};

export const Menu = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M4 6h16M4 12h16M4 18h16"
      />
    </svg>
  );
};

export const ArrowRight = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M17 8l4 4m0 0l-4 4m4-4H3"
      />
    </svg>
  );
};

export const ArrowLeft = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M7 16l-4-4m0 0l4-4m-4 4h18"
      />
    </svg>
  );
};

export const Calendar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-6 h-6"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
    />
  </svg>
);

export const ArrowUpright = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={3}
    stroke="currentColor"
    className="w-6 h-6"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"
    />
  </svg>
);

export const Duplicate = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"
    />
  </svg>
);

export const EyeIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="size-6"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
      />
    </svg>
  );
};

export const Chat = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-6 h-6"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 0 1-.825-.242m9.345-8.334a2.126 2.126 0 0 0-.476-.095 48.64 48.64 0 0 0-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0 0 11.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"
    />
  </svg>
);

const icons = {
  Messenger: (props) => (
    <svg {...props} viewBox="0 0 56.7 56.7" fill="currentColor">
      <path d="M28.4342,3.8416c-13.4521,0-24.3571,10.1599-24.3571,22.693c0,7.1415,3.5419,13.5115,9.0772,17.6713v8.6525l8.2934-4.5799 c2.2133,0.6163,4.5581,0.949,6.9866,0.949c13.4521,0,24.3571-10.1599,24.3571-22.693S41.8863,3.8416,28.4342,3.8416z M30.8548,34.4015l-6.2027-6.6566l-12.1029,6.6566l13.3132-14.2209l6.354,6.6566l11.9516-6.6566L30.8548,34.4015z" />
    </svg>
  ),
  Instagram: (props) => (
    <svg {...props} viewBox="0 0 17 17" fill="currentColor" stroke="none">
      <path d="M13.6683 4.78509C13.6683 4.90669 13.6443 5.02711 13.5978 5.13945C13.5513 5.2518 13.483 5.35388 13.3971 5.43987C13.3111 5.52586 13.209 5.59406 13.0966 5.6406C12.9843 5.68714 12.8639 5.71109 12.7423 5.71109C12.6207 5.71109 12.5003 5.68714 12.3879 5.6406C12.2756 5.59406 12.1735 5.52586 12.0875 5.43987C12.0015 5.35388 11.9333 5.2518 11.8868 5.13945C11.8402 5.02711 11.8163 4.90669 11.8163 4.78509C11.8163 4.5395 11.9138 4.30397 12.0875 4.13031C12.2612 3.95665 12.4967 3.85909 12.7423 3.85909C12.9879 3.85909 13.2234 3.95665 13.3971 4.13031C13.5707 4.30397 13.6683 4.5395 13.6683 4.78509ZM16.6083 8.96509V8.97709L16.5553 12.3331C16.5418 13.5434 16.055 14.7004 15.1992 15.5563C14.3435 16.4123 13.1866 16.8993 11.9763 16.9131L8.60828 16.9651H8.59628L5.24028 16.9121C4.02995 16.8986 2.87299 16.4118 2.01702 15.5561C1.16104 14.7003 0.674051 13.5434 0.660276 12.3331L0.608276 8.96509V8.95309L0.661276 5.59709C0.674786 4.38676 1.16152 3.2298 2.01731 2.37383C2.8731 1.51785 4.02995 1.03086 5.24028 1.01709L8.60828 0.965088H8.62028L11.9763 1.01809C13.1866 1.0316 14.3436 1.51833 15.1995 2.37412C16.0555 3.22991 16.5425 4.38676 16.5563 5.59709L16.6083 8.96509ZM15.1183 8.96509L15.0663 5.62009C15.0569 4.79737 14.7259 4.01099 14.1442 3.4292C13.5624 2.84742 12.776 2.51644 11.9533 2.50709L8.60828 2.45509L5.26328 2.50709C4.44056 2.51644 3.65418 2.84742 3.07239 3.4292C2.49061 4.01099 2.15963 4.79737 2.15028 5.62009L2.09828 8.96509L2.15028 12.3101C2.15963 13.1328 2.49061 13.9192 3.07239 14.501C3.65418 15.0828 4.44056 15.4137 5.26328 15.4231L8.60828 15.4751L11.9533 15.4231C12.776 15.4137 13.5624 15.0828 14.1442 14.501C14.7259 13.9192 15.0569 13.1328 15.0663 12.3101L15.1183 8.96509ZM12.7163 8.96509C12.7163 10.0546 12.2835 11.0995 11.5131 11.8699C10.7427 12.6403 9.69779 13.0731 8.60828 13.0731C7.51877 13.0731 6.47388 12.6403 5.70348 11.8699C4.93308 11.0995 4.50028 10.0546 4.50028 8.96509C4.50028 7.87558 4.93308 6.83069 5.70348 6.06029C6.47388 5.28989 7.51877 4.85709 8.60828 4.85709C9.69779 4.85709 10.7427 5.28989 11.5131 6.06029C12.2835 6.83069 12.7163 7.87558 12.7163 8.96509ZM11.2263 8.96509C11.2263 8.27075 10.9505 7.60485 10.4595 7.11388C9.96851 6.62291 9.30261 6.34709 8.60828 6.34709C7.91394 6.34709 7.24804 6.62291 6.75707 7.11388C6.2661 7.60485 5.99028 8.27075 5.99028 8.96509C5.99028 9.65942 6.2661 10.3253 6.75707 10.8163C7.24804 11.3073 7.91394 11.5831 8.60828 11.5831C9.30261 11.5831 9.96851 11.3073 10.4595 10.8163C10.9505 10.3253 11.2263 9.65942 11.2263 8.96509Z" />
    </svg>
  ),
  Facebook: (props) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      store="currentColor"
    >
      <path d="M17.5 0H2.5C1.12125 0 0 1.12125 0 2.5V17.5C0 18.8787 1.12125 20 2.5 20H10V13.125H7.5V10H10V7.5C10 5.42875 11.6788 3.75 13.75 3.75H16.25V6.875H15C14.31 6.875 13.75 6.81 13.75 7.5V10H16.875L15.625 13.125H13.75V20H17.5C18.8787 20 20 18.8787 20 17.5V2.5C20 1.12125 18.8787 0 17.5 0Z" />
    </svg>
  ),
  Clock: (props) => (
    <svg {...props} fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  ),
  Menu: (props) => (
    <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M4 6h16M4 12h16M4 18h16"
      />
    </svg>
  ),
  Close: (props) => (
    <svg {...props}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  ),
  CloseLight: (props) => (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 10 10"
      fill="currentColor"
      stroke="none"
    >
      <path d="M0.0884023 9.91162C0.147321 9.97051 0.224536 9.99998 0.30175 9.99998C0.378965 9.99998 0.45618 9.97051 0.515099 9.91162L5 5.42669L9.48492 9.91164C9.54381 9.97054 9.62108 10 9.69829 10C9.77548 10 9.8527 9.97054 9.91164 9.91164C10.0295 9.79383 10.0295 9.60278 9.91164 9.48492L5.42669 5L9.91164 0.515075C10.0295 0.397237 10.0295 0.206216 9.91164 0.0883782C9.7938 -0.0294594 9.60278 -0.0294594 9.48492 0.0883782L5 4.5733L0.515075 0.0884264C0.397237 -0.0294111 0.206216 -0.0294111 0.0883781 0.0884264C-0.0294594 0.20624 -0.0294594 0.397285 0.0883781 0.515123L4.5733 5.00002L0.0884023 9.48492C-0.0294352 9.60276 -0.0294352 9.7938 0.0884023 9.91162Z" />
    </svg>
  ),
  Duplicate: (props) => (
    <svg {...props} viewBox="0 0 21 20" fill="currentColor" stroke="none">
      <path d="M6.2699 8.57143C6.2699 7.81367 6.57092 7.08694 7.10674 6.55112C7.64256 6.01531 8.36928 5.71429 9.12705 5.71429H17.6985C18.4563 5.71429 19.183 6.01531 19.7188 6.55112C20.2546 7.08694 20.5556 7.81367 20.5556 8.57143V17.1429C20.5556 17.9006 20.2546 18.6273 19.7188 19.1632C19.183 19.699 18.4563 20 17.6985 20H9.12705C8.36928 20 7.64256 19.699 7.10674 19.1632C6.57092 18.6273 6.2699 17.9006 6.2699 17.1429V8.57143Z" />
      <path d="M3.41269 0C2.65493 0 1.9282 0.301019 1.39238 0.836838C0.856562 1.37266 0.555542 2.09938 0.555542 2.85714V11.4286C0.555542 12.1863 0.856562 12.9131 1.39238 13.4489C1.9282 13.9847 2.65493 14.2857 3.41269 14.2857V2.85714H14.8413C14.8413 2.09938 14.5403 1.37266 14.0044 0.836838C13.4686 0.301019 12.7419 0 11.9841 0H3.41269Z" />
    </svg>
  ),
};

export default function Icon({ name, withHover, ...rest }) {
  const commonIconProps = useMemo(
    () => ({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
    }),
    []
  );
  const tranistionProperties =
    "cursor-pointer transition-color duration-500 hover:text-black";

  const className = cn(
    "w-4 h-4",
    {
      [tranistionProperties]: withHover,
    },
    rest.className
  );

  const Component = icons[name];

  return Component ? (
    <Component {...commonIconProps} {...rest} className={className} />
  ) : null;
}
